import { Activity, Clock, Pause, Timer } from "lucide-react";
import { comparisonLabel } from "./dateRange";
import { formatDuration } from "./formatters";
import { kpiTrend } from "./kpiTrend";

export default function OverallKpiCards({ kpis, preset }) {
  const compare = comparisonLabel(preset);
  const cards = [
    {
      key: "active",
      label: "Active time",
      tone: "active",
      Icon: Activity,
      value: formatDuration(kpis.activeSeconds),
      trend: kpiTrend(kpis.activeSeconds, kpis.priorActiveSeconds, compare, { duration: true }),
    },
    {
      key: "sessions",
      label: "Sessions",
      tone: "sessions",
      Icon: Timer,
      value: kpis.sessionCount,
      trend: kpiTrend(kpis.sessionCount, kpis.priorSessionCount, compare),
    },
    {
      key: "avg",
      label: "Avg session",
      tone: "avg",
      Icon: Clock,
      value: formatDuration(kpis.avgSessionSeconds),
      trend: kpiTrend(kpis.avgSessionSeconds, kpis.priorAvgSessionSeconds, compare, { duration: true }),
    },
    {
      key: "pause",
      label: "Pause time",
      tone: "pause",
      Icon: Pause,
      value: formatDuration(kpis.pauseSeconds),
      trend: kpiTrend(kpis.pauseSeconds, kpis.priorPauseSeconds, compare, { duration: true }),
    },
  ];

  return (
    <section className="pa-kpi-board" aria-label="Period summary">
      {cards.map((card) => {
        const Icon = card.Icon;
        return (
          <article key={card.key} className={`pa-kpi-card pa-kpi-card--${card.tone}`}>
            <div className="pa-kpi-card__top">
              <p className="pa-kpi__label">{card.label}</p>
              <span className="pa-kpi-card__icon" aria-hidden="true">
                <Icon size={16} />
              </span>
            </div>
            <p className="pa-kpi-card__value">{card.value}</p>
            <p className={`pa-kpi-card__trend pa-kpi-card__trend--${card.trend.tone}`}>
              {card.trend.tone === "up" ? "↑ " : card.trend.tone === "down" ? "↓ " : ""}
              {card.trend.text}
            </p>
          </article>
        );
      })}
    </section>
  );
}
